// The tender's pointers to the same call published on another platform. Other relation
// types (e.g. supersedes, amends) would need their own wording, so they are left out.
export const sameTenderSources = (tender) =>
  ((tender && tender.relatedSources) || []).filter((relatedSource) => relatedSource.relationType === 'same-tender');
